export enum NewDispatcherStatusesEnum {
    'Прибывающие' = 'yellow',
    'Фактические' = 'green',
}
